import { Extension } from '@tiptap/core';

const isWithinBounds = (inner, outer) => {
  const innerRect = inner.getBoundingClientRect();
  const outerRect = outer.getBoundingClientRect();

  return (
    innerRect.top >= outerRect.top &&
    innerRect.left >= outerRect.left &&
    innerRect.bottom <= outerRect.bottom &&
    innerRect.right <= outerRect.right
  );
};

const HideMenusOnScroll = Extension.create({
  name: 'HideMenusOnScroll',
  onCreate({ editor }) {
    const editorPageContainer = editor.view.dom.parentNode;
    const application = editorPageContainer.closest('[role="application"]');
    const handleMenusVisibility = () => {
      requestAnimationFrame(() => {
        const hideOnScrollSources = application.querySelectorAll('[data-js-visibility-trigger]');
        const selector = '[data-js-visibility-target]';

        for (const el of hideOnScrollSources) {
          const hideOnScrollTarget = el.closest(selector) || el;
          const hide = !isWithinBounds(el, editorPageContainer);

          hideOnScrollTarget?.classList.toggle('hidden', hide);
        }
      });
    };

    editorPageContainer.addEventListener('click', handleMenusVisibility);
    editorPageContainer.addEventListener('scroll', handleMenusVisibility);
    document.addEventListener('wheel', handleMenusVisibility);
    document.addEventListener('onwheel', handleMenusVisibility);
  },
});

export default [HideMenusOnScroll];
